import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TextSizeService {
  private readonly STORAGE_KEY = 'userTextSizeScale';
  private readonly DEFAULT_SCALE = 1.0;
  private readonly MIN_SCALE = 0.85;
  private readonly MAX_SCALE = 1.3;

  private textScaleSubject = new BehaviorSubject<number>(this.DEFAULT_SCALE);
  public textScale$ = this.textScaleSubject.asObservable();

  constructor() {
    this.loadTextScale();
  }

  private loadTextScale(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    const scale = saved ? parseFloat(saved) : this.DEFAULT_SCALE;
    this.setTextScale(scale);
  }

  public setTextScale(scale: number): void {
    // Clamp to valid range
    const clampedScale = Math.max(this.MIN_SCALE, Math.min(this.MAX_SCALE, scale));

    // Update CSS variable on document root
    document.documentElement.style.setProperty('--text-scale-factor', clampedScale.toString());

    // Save to localStorage
    localStorage.setItem(this.STORAGE_KEY, clampedScale.toString());

    // Emit change
    this.textScaleSubject.next(clampedScale);
  }

  public getTextScale(): number {
    return this.textScaleSubject.value;
  }

  public resetTextScale(): void {
    this.setTextScale(this.DEFAULT_SCALE);
  }

  public get minScale(): number { return this.MIN_SCALE; }
  public get maxScale(): number { return this.MAX_SCALE; }
  public get defaultScale(): number { return this.DEFAULT_SCALE; }
}
